// extracted by mini-css-extract-plugin
module.exports = {"welcomeContainer":"welcome-page_welcomeContainer__15qXi"};